import React from "react";
import "./../styles/Privacy.css";

const Privacy = () => {
  return (
    <div className="lh-legal-page">
      <section className="lh-legal-hero">
        <p className="lh-legal-eyebrow">Datenschutz</p>
        <h1>Datenschutzrichtlinie</h1>
        <p>
          Wir schützen deine Daten nach hohen akademischen Standards und legen die
          Verarbeitung transparent dar.
        </p>
      </section>

      <section className="lh-legal-layout">
        <aside className="lh-legal-toc">
          <p>Inhaltsverzeichnis</p>
          <a href="#privacy-1">1. Allgemeines</a>
          <a href="#privacy-2">2. Welche Daten erheben wir?</a>
          <a href="#privacy-3">3. Wie verwenden wir deine Daten?</a>
          <a href="#privacy-4">4. Deine Rechte</a>
          <a href="#privacy-5">5. Sicherheit deiner Daten</a>
          <a href="#privacy-6">6. Speicherdauer</a>
          <a href="#privacy-7">7. Änderungen der Datenschutzrichtlinie</a>
        </aside>

        <article className="lh-legal-article">
          <section id="privacy-1">
            <h2>1. Allgemeines</h2>
            <p>
              Wir legen großen Wert auf den Schutz deiner persönlichen Daten. Diese
              Datenschutzrichtlinie beschreibt, wie wir deine Daten erheben,
              verarbeiten und speichern, wenn du unsere Plattform nutzt.
            </p>
          </section>

          <section id="privacy-2">
            <h2>2. Welche Daten erheben wir?</h2>
            <p>
              Wir erheben nur die Daten, die notwendig sind, um unsere Dienste
              bereitzustellen. Dazu gehören:
            </p>
            <ul>
              <li>Registrierungsdaten (z. B. Name, E-Mail-Adresse).</li>
              <li>Nutzungsdaten (z. B. besuchte Seiten, genutzte Funktionen).</li>
              <li>Zahlungsinformationen, falls erforderlich.</li>
            </ul>
          </section>

          <section id="privacy-3">
            <h2>3. Wie verwenden wir deine Daten?</h2>
            <ul>
              <li>Zur Bereitstellung und Verbesserung unserer Dienste.</li>
              <li>Für die Kommunikation mit dir, z. B. bei Support-Anfragen.</li>
              <li>
                Um dir Zugang zu Kursmaterialien und Prüfungsvorbereitungen zu
                ermöglichen.
              </li>
            </ul>
            <p>
              Deine Daten werden nicht verkauft oder an Dritte weitergegeben, außer
              wenn dies gesetzlich vorgeschrieben ist oder zur Erfüllung unserer
              Dienste notwendig ist (z. B. Zahlungsabwicklung).
            </p>
          </section>

          <section id="privacy-4">
            <h2>4. Deine Rechte</h2>
            <p>Du hast folgende Rechte gemäß der DSGVO:</p>
            <ul>
              <li>
                Recht auf Auskunft über die gespeicherten Daten (Art. 15 DSGVO).
              </li>
              <li>Recht auf Berichtigung unrichtiger Daten (Art. 16 DSGVO).</li>
              <li>Recht auf Löschung deiner Daten (Art. 17 DSGVO).</li>
            </ul>
          </section>

          <section id="privacy-5">
            <h2>5. Sicherheit deiner Daten</h2>
            <p>
              Wir nutzen technische und organisatorische Maßnahmen, um deine Daten
              vor unbefugtem Zugriff, Verlust oder Missbrauch zu schützen. Deine
              Daten werden verschlüsselt übertragen (z. B. SSL).
            </p>
          </section>

          <section id="privacy-6">
            <h2>6. Speicherdauer</h2>
            <p>
              Deine Daten werden nur so lange gespeichert, wie es zur Erfüllung
              unserer Dienste notwendig ist oder gesetzliche Vorgaben dies
              verlangen.
            </p>
          </section>

          <section id="privacy-7">
            <h2>7. Änderungen der Datenschutzrichtlinie</h2>
            <p>
              Diese Datenschutzrichtlinie kann bei Bedarf aktualisiert werden, z. B.
              bei Änderungen unserer Dienste oder rechtlicher Anforderungen. Wir
              empfehlen, diese Seite regelmäßig zu überprüfen.
            </p>
          </section>
        </article>
      </section>
    </div>
  );
};

export default Privacy;
